var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"ctk-timeslot-date",class:_vm.data.staticClass,style:(_vm.data.staticStyle)},[_c('span',{staticClass:"ctk-timeslot-date__sign",class:{
      'ctk-timeslot-date__sign--flexible': _vm.props.flexible,
      'tw-text-red-500': !_vm.props.flexible
    }},[_vm._v(" "+_vm._s(_vm.props.flexible ? (_vm.props.direction === 'pickup' ? '≥' : '≤') : '=')+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }